import {Box, InputLabel, MenuItem, Select, Typography} from '@mui/material';
import {lineStyleChoices} from '../../utils/choices';
import {memo} from 'react';

const MhdLineStyleChoices = ({ label, value, onChange, disabled }) => {
  return (
    <>
      <InputLabel variant='primary'>
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
      {lineStyleChoices.map((choice) => (
        <MenuItem
          key={choice.value}
          value={choice.value}
        >
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '10px',
            width: 1}}
          >
            {choice.label}
          </Box>
        </MenuItem>
      ))}
      </Select>
    </>
  );
};

export default memo(MhdLineStyleChoices);